import { Component, Vue } from "vue-property-decorator";

// External components
import BasicHeader from "@/components/basicHeader/basicHeader";

@Component({ components: { BasicHeader } })
export default class SubscriptionBase extends Vue {
  get isShowingBasicHeader() {
    const { name } = this.$route;
    if (name === "chefSuggestions" || name === "changeProduct") {
      return true;
    }
    return false;
  }
}
